var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon XS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M15.0228 10.7433C15.0228 9.45639 15.6141 8.51727 16.7619 7.78685C16.1011 6.84774 15.1272 6.36079 13.8403 6.25645C12.5881 6.1521 11.2316 6.95209 10.7447 6.95209C10.2229 6.95209 9.04035 6.29123 8.10124 6.29123C6.15345 6.32601 4.10132 7.82164 4.10132 10.9172C4.10132 11.8216 4.24045 12.7607 4.58827 13.7346C5.04043 15.0215 6.6404 18.1519 8.30993 18.0823C9.17948 18.0823 9.80556 17.4562 10.9534 17.4562C12.0664 17.4562 12.6229 18.0823 13.5968 18.0823C15.3011 18.0823 16.7619 15.2302 17.1793 13.9433C14.9185 12.865 15.0228 10.8129 15.0228 10.7433ZM13.0751 5.03908C14.0142 3.92606 13.9098 2.8826 13.9098 2.5C13.0751 2.56956 12.1012 3.09129 11.5447 3.71737C10.9186 4.41301 10.5708 5.28255 10.6403 6.22167C11.5447 6.29123 12.3794 5.83907 13.0751 5.03908Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogoWhite);
export default __webpack_public_path__ + "static/media/apple-logo-white.fd286f4fc350aad474cc89f1399fdb80.svg";
export { ForwardRef as ReactComponent };